module.exports = __webpack_public_path__ + "static/pokoj-nr5-photo02-ff7ae9675353fec836ef9bb061a6304b.jpg";